<template>
	<div>
		<b-card>
			<b-tabs v-model="tab" pills card justified>
				<b-tab :key="0" :title="`Мин (${minMaxItemsCount.min})`">
					<b-row class="mb-3">
						<b-col>
							<multiselect
								label="name"
								track-by="id"
								:multiple="true"
								:allow-empty="true"
								:group-select="true"
								:show-labels="false"
								:options="departments"
								v-model="departmentId"
								class="multiselect-pricing"
								:placeholder="$t('promo-to-product.department')"
							/>
						</b-col>
						<b-col>
							<b-form-input
								v-model="filter.value"
								@keyup.enter="getList"
								:placeholder="`${$t('goods.name')}, ${$t('goods.special-barcode')}, ${$t('goods.barcode')}`"
							/>
						</b-col>
						<b-col>
							<multiselect
								label="name"
								track-by="id"
								:multiple="true"
								:options="groups"
								v-model="groupId"
								:allow-empty="true"
								:group-select="true"
								:show-labels="false"
								class="multiselect-pricing"
								:placeholder="$t('goods.create.select-group')"
							/>
						</b-col>
						<b-col cols="1">
							<b-button @click="getList" variant="dark" class="fa fa-search"/>
						</b-col>
					</b-row>
					<b-table :items="minItems" :fields="fieldsMin" show-empty hover striped bordered :busy="loading">
						<template slot="index" slot-scope="data">
							{{ data.index + 1 }}
						</template>
					</b-table>
				</b-tab>
				<b-tab :key="1" :title="`Макс (${minMaxItemsCount.max})`">
					<b-row class="mb-3">
						<b-col>
							<multiselect
								label="name"
								track-by="id"
								:multiple="true"
								:allow-empty="true"
								:group-select="true"
								:show-labels="false"
								:options="departments"
								v-model="departmentId"
								class="multiselect-pricing"
								:placeholder="$t('promo-to-product.department')"
							/>
						</b-col>
						<b-col>
							<b-form-input
								v-model="filter.value"
								@keyup.enter="getList"
								:placeholder="`${$t('goods.name')}, ${$t('goods.special-barcode')}, ${$t('goods.barcode')}`"
							/>
						</b-col>
						<b-col>
							<multiselect
								label="name"
								track-by="id"
								:multiple="true"
								:options="groups"
								v-model="groupId"
								:allow-empty="true"
								:group-select="true"
								:show-labels="false"
								class="multiselect-pricing"
								:placeholder="$t('goods.create.select-group')"
							/>
						</b-col>
						<b-col cols="1">
							<b-button @click="getList" variant="dark" class="fa fa-search"/>
						</b-col>
					</b-row>
					<b-table :items="maxItems" :fields="fieldsMax" show-empty hover striped bordered :busy="loading">
						<template slot="index" slot-scope="data">
							{{ data.index + 1 }}
						</template>
					</b-table>
				</b-tab>
			</b-tabs>
		</b-card>
	</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import UsersService from "../../../services/users.sevice";
import {TokenService} from "../../../services/storage.service";
import ReferencesService from "../../../services/references.sevice";
import itemValuesService from "./item.values.service";

export default {
	name: "index",
	components: {Multiselect},
	data() {
		return {
			tab: 0,
			loading: false,
			filter: {
				value: '',
				depIds: [],
				groupIds: []
			},
			minMaxItemsCount: {},
			departments: [],
			departmentId: null,
			groups: [],
			groupId: null,
			fieldsMin: [
				{key: 'index', label: '№', class: 'text-center',visible: true },
				{key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center', visible: true,sortable: true},
				{key: 'multiBarcode', label: this.$t('goods.barcode'), class: 'text-center', visible: true,sortable: true},
				{key: 'itemName', label: this.$t('pos.product'), class: 'text-center', visible: true,sortable: true},
				{key: 'departmentName', label: this.$t('promo-to-product.department'), class: 'text-center', visible: true,sortable: true},
				{key: 'groupName', label: this.$t('contragent.group-name'), class: 'text-center', visible: true,sortable: true},
				{key: 'subGroupName', label: this.$t('subGroup'), class: 'text-center', visible: true,sortable: true},
				{key: 'remaining', label: this.$t('remaining'), class: 'text-center', visible: true,sortable: true},
				{key: 'minValue', label: 'Мин. знач', class: 'text-center', visible: true,sortable: true}
			],
			fieldsMax: [
				{key: 'index', label: '№', class: 'text-center',visible: true },
				{key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center', visible: true,sortable: true},
				{key: 'multiBarcode', label: this.$t('goods.barcode'), class: 'text-center', visible: true,sortable: true},
				{key: 'itemName', label: this.$t('pos.product'), class: 'text-center', visible: true,sortable: true},
				{key: 'departmentName', label: this.$t('promo-to-product.department'), class: 'text-center', visible: true,sortable: true},
				{key: 'groupName', label: this.$t('contragent.group-name'), class: 'text-center', visible: true,sortable: true},
				{key: 'subGroupName', label: this.$t('subGroup'), class: 'text-center', visible: true,sortable: true},
				{key: 'remaining', label: this.$t('remaining'), class: 'text-center', visible: true,sortable: true},
				{key: 'maxValue', label: 'Мах. знач', class: 'text-center', visible: true,sortable: true}
			],
			minItems: [],
			maxItems: []
		}
	},
	watch: {
		'tab': {
			handler(t) {
				this.getList();
			}
		},
		'departmentId': {
			handler(d) {
				if (d) {
					this.filter.depIds = []
					d.forEach(dep => {
						this.filter.depIds.push(dep.id)
					})
				}
			}
		},
		'groupId': {
			handler(g) {
				if (g) {
					this.filter.groupIds = []
					g.forEach(group => {
						this.filter.groupIds.push(group.id)
					})
				}
			}
		}
	},
	methods: {
		getList() {
			this.loading = true
			if (this.tab===0) {
				itemValuesService.getMinValuesList(this.filter).then(res => {
					this.minItems = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				itemValuesService.getMaxValuesList(this.filter).then(res => {
					this.maxItems = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			}
		}
	},
	async created() {
		this.loading = true
		await itemValuesService.getItemValuesCounts().then(res => {
			this.minMaxItemsCount = res.data
		})
		await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
			this.departments = response.data.permittedDepartments
		}).catch(e => {console.log(e)})
		await ReferencesService.getReferenceChildren(`MAGAZIN`).then(response => {
			this.groups = response.data;
		}).catch(e => {console.log(e)})
		await this.getList();
		this.loading = false
	}
}
</script>

<style scoped>

</style>
